import '../i18n';

import { BackToTop } from 'material-ui-back-to-top';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet';
import NavbarWhite from '../components/navbar/NavbarWhite';
import PrivacyPolicyBody from '../components/PrivacyPolicyBody';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Helmet>
        <title>{t('seo.page.privacyPolicy.title')}</title>
      </Helmet>
      <BackToTop size="small" buttonPosition={{ bottom: 20, right: 20 }} />
      <NavbarWhite />
      <PrivacyPolicyBody />
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
